(function () {
  'use strict';

  var SKIN_QUIZ_STORAGE_KEY = 'dearme_skin_quiz_results';

  var QUIZ_QUESTIONS = [
    {
      id: 'q1',
      text: 'How does your skin usually feel by midday?',
      options: [
        { label: 'Tight and dry', score: 12 },
        { label: 'Oily and heavy', score: 13 },
        { label: 'Fine in some areas, rough in others', score: 14 },
        { label: "Dull, like it's just there", score: 15 }
      ]
    },
    {
      id: 'q2',
      text: 'If you could fix one thing about your skin tomorrow, what would it be?',
      options: [
        { label: 'These dark spots and uneven patches', score: 20 },
        { label: "The dullness: I've lost my glow", score: 20 },
        { label: "Acne marks that just won't fade", score: 18 },
        { label: 'Overall texture feels rough and tired', score: 16 }
      ]
    },
    {
      id: 'q3',
      text: 'How long has this been bothering you?',
      options: [
        { label: "It's recent (a few weeks)", score: 10 },
        { label: 'A few months now', score: 10 },
        { label: "It's been over a year", score: 9 },
        { label: 'It comes and goes with my lifestyle', score: 8 }
      ]
    },
    {
      id: 'q4',
      text: 'How does your skin usually respond to new products?',
      options: [
        { label: 'Reacts quickly: redness, irritation', score: 20 },
        { label: 'Occasional breakouts but mostly fine', score: 19 },
        { label: 'Takes time to adjust but settles', score: 18 },
        { label: 'My skin is quite easygoing', score: 17 }
      ]
    },
    {
      id: 'q5',
      text: 'What does your skincare routine look like right now?',
      options: [
        { label: 'I barely have one', score: 8 },
        { label: "Cleanser and moisturiser, that's it", score: 9 },
        { label: 'A few products, no real order', score: 9 },
        { label: 'A proper AM/PM routine', score: 10 }
      ]
    },
    {
      id: 'q6',
      text: 'Pick what best describes your day-to-day:',
      options: [
        { label: 'Long screen hours, high stress', score: 8 },
        { label: 'Outdoors often, sun exposure is regular', score: 9 },
        { label: 'Irregular sleep, irregular everything', score: 8 },
        { label: 'Fairly balanced, but skin still struggles', score: 10 }
      ]
    },
    {
      id: 'q7',
      text: 'What matters more to you in a skincare product?',
      options: [
        { label: 'Fast, visible results', score: 9 },
        { label: 'Gentle, skin-safe ingredients', score: 10 },
        { label: 'Something rooted in science and nature', score: 10 },
        { label: 'Long-term skin health over quick fixes', score: 10 }
      ]
    },
    {
      id: 'q8',
      text: 'Where are you in your skincare journey?',
      options: [
        { label: 'Just starting out, need direction', score: 4 },
        { label: "Tried a lot, nothing has worked", score: 5 },
        { label: 'Know what I want, need the right product', score: 5 },
        { label: "Open to learning what's right for me", score: 4 }
      ]
    }
  ];

  var RESULT_BANDS = [
    {
      min: 93,
      percent: 98,
      copy:
        'Your skin and Sacred Secret are practically made for each other. With the right AM/PM routine, results will follow.'
    },
    {
      min: 88,
      percent: 92,
      copy:
        'Sacred Secret is a strong match. The right routine will unlock everything. Let us build one for you.'
    },
    {
      min: 83,
      percent: 87,
      copy: 'With a personalised AM/PM routine, Sacred Secret will work beautifully for your skin.'
    },
    {
      min: 0,
      percent: 85,
      copy:
        "Your skin needs a little extra care, and that's exactly what we're here for. A free consult will make all the difference."
    }
  ];

  function getResultFromScore(totalScore) {
    for (var i = 0; i < RESULT_BANDS.length; i++) {
      if (totalScore >= RESULT_BANDS[i].min) {
        return RESULT_BANDS[i];
      }
    }
    return RESULT_BANDS[RESULT_BANDS.length - 1];
  }

  function trackEvent(name, payload) {
    var detail = Object.assign({ event: name }, payload || {});
    document.dispatchEvent(new CustomEvent('skin-quiz:event', { detail: detail }));

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish('skin_quiz_' + name, payload || {});
      } catch (e) {
        /* ignore */
      }
    }
  }

  function animateCounter(el, target, duration) {
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(start + (target - start) * eased);
      el.textContent = value + '%';
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  function saveQuizResults(answers, resultMeta) {
    try {
      localStorage.setItem(
        SKIN_QUIZ_STORAGE_KEY,
        JSON.stringify({
          answers: answers,
          resultMeta: resultMeta,
          savedAt: Date.now()
        })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function readQuizResults() {
    try {
      var raw = localStorage.getItem(SKIN_QUIZ_STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearQuizResults() {
    try {
      localStorage.removeItem(SKIN_QUIZ_STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function isClickInsideAppForm(event, quizRoot) {
    var path = event.composedPath ? event.composedPath() : [event.target];

    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.tagName) continue;
      if (el === quizRoot) return false;
      if (el.tagName === 'FORM-EMBED') return true;
    }

    return false;
  }

  function hasAppForm(appBlocks) {
    return !!(appBlocks && appBlocks.querySelector('form-embed'));
  }

  function watchAppForm(appBlocks, onSubmit, onSuccess) {
    if (!appBlocks || appBlocks.dataset.quizFormWatchInit === 'true') return;
    appBlocks.dataset.quizFormWatchInit = 'true';

    function bindFormEmbed(formEmbed) {
      if (!formEmbed || formEmbed.dataset.quizFormWatchInit === 'true') return;
      formEmbed.dataset.quizFormWatchInit = 'true';

      function bindShadow(shadowRoot) {
        if (!shadowRoot || shadowRoot.dataset.quizFormWatchInit === 'true') return;
        shadowRoot.dataset.quizFormWatchInit = 'true';

        var appEmbed = shadowRoot.querySelector('#app-embed');
        if (appEmbed && onSuccess) {
          var stepObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.attributeName !== 'data-current-step') return;
              var step = appEmbed.getAttribute('data-current-step') || '';
              if (step.indexOf('success') !== -1 || step.indexOf('thank') !== -1) {
                onSuccess();
              }
            });
          });
          stepObserver.observe(appEmbed, { attributes: true });
        }

        var form = shadowRoot.querySelector('form');
        if (form && onSubmit) {
          form.addEventListener('submit', onSubmit, true);
        }

        if (onSubmit) {
          shadowRoot.addEventListener(
            'click',
            function (event) {
              var target = event.target;
              if (!target || !target.tagName) return;
              var tag = target.tagName.toLowerCase();
              if (tag === 'button' || (tag === 'input' && target.type === 'submit')) {
                onSubmit();
              }
            },
            true
          );
        }
      }

      if (formEmbed.shadowRoot) {
        bindShadow(formEmbed.shadowRoot);
      }

      var embedObserver = new MutationObserver(function () {
        if (formEmbed.shadowRoot) bindShadow(formEmbed.shadowRoot);
      });
      embedObserver.observe(formEmbed, { childList: true, subtree: true });
    }

    appBlocks.querySelectorAll('form-embed').forEach(bindFormEmbed);

    var blocksObserver = new MutationObserver(function () {
      appBlocks.querySelectorAll('form-embed').forEach(bindFormEmbed);
    });
    blocksObserver.observe(appBlocks, { childList: true, subtree: true });
  }

  function initQuiz(root) {
    if (!root || root.dataset.skinQuizInit === 'true') return;
    root.dataset.skinQuizInit = 'true';

    var totalQuestions = QUIZ_QUESTIONS.length;
    var answers = {};
    var currentStep = 'intro';
    var currentQuestion = 0;
    var pendingResultMeta = null;
    var leadCompleted = false;

    var screens = {
      intro: root.querySelector('[data-quiz-screen="intro"]'),
      question: root.querySelector('[data-quiz-screen="question"]'),
      lead: root.querySelector('[data-quiz-screen="lead"]'),
      result: root.querySelector('[data-quiz-screen="result"]')
    };

    var progressWrap = root.querySelector('[data-quiz-progress]');
    var progressBar = root.querySelector('[data-quiz-progress-bar]');
    var progressLabel = root.querySelector('[data-quiz-progress-label]');
    var questionTitle = root.querySelector('[data-quiz-question-title]');
    var optionsList = root.querySelector('[data-quiz-options]');
    var backBtn = root.querySelector('[data-quiz-back]');
    var startBtn = root.querySelector('[data-quiz-start]');
    var appBlocks = root.querySelector('[data-quiz-app-blocks]');
    var resultPercent = root.querySelector('[data-quiz-result-percent]');
    var resultCopy = root.querySelector('[data-quiz-result-copy]');
    var retakeBtn = root.querySelector('[data-quiz-retake]');

    function showScreen(name) {
      Object.keys(screens).forEach(function (key) {
        if (!screens[key]) return;
        screens[key].hidden = key !== name;
      });
      currentStep = name;

      if (name === 'lead') {
        prepareLeadScreen();
      }
    }

    function updateProgress() {
      if (!progressBar || !progressLabel) return;

      var showProgress = currentStep === 'question';
      if (progressWrap) {
        progressWrap.hidden = !showProgress;
      }

      if (!showProgress) {
        progressBar.style.width = '0%';
        progressLabel.textContent = '';
        return;
      }

      var step = currentQuestion + 1;
      var percent = (step / totalQuestions) * 100;
      progressBar.style.width = percent + '%';
      progressLabel.textContent = step + ' of ' + totalQuestions;
    }

    function calculateTotalScore() {
      var total = 0;
      QUIZ_QUESTIONS.forEach(function (question) {
        var selected = answers[question.id];
        if (typeof selected === 'number' && question.options[selected]) {
          total += question.options[selected].score;
        }
      });
      return total;
    }

    function buildResultMeta() {
      var rawScore = calculateTotalScore();
      var result = getResultFromScore(rawScore);
      return {
        percent: result.percent,
        rawScore: rawScore,
        copy: result.copy
      };
    }

    function persistResultsForRedirect() {
      if (!pendingResultMeta) pendingResultMeta = buildResultMeta();
      saveQuizResults(answers, pendingResultMeta);
    }

    function onLeadFormPointerDown(event) {
      if (currentStep !== 'lead') return;
      if (!isClickInsideAppForm(event, root)) return;

      var target = event.target;
      if (!target || !target.tagName) return;

      var tag = target.tagName.toLowerCase();
      if (tag === 'button' || (tag === 'input' && (target.type === 'submit' || target.type === 'button'))) {
        persistResultsForRedirect();
      }
    }

    root.addEventListener('pointerdown', onLeadFormPointerDown, true);

    function prepareLeadScreen() {
      pendingResultMeta = buildResultMeta();
      leadCompleted = false;
      saveQuizResults(answers, pendingResultMeta);

      function attachFormWatch(attempt) {
        attempt = attempt || 0;
        if (hasAppForm(appBlocks)) {
          watchAppForm(
            appBlocks,
            persistResultsForRedirect,
            function () {
              persistResultsForRedirect();
              window.setTimeout(function () {
                if (currentStep === 'lead' && !leadCompleted) {
                  completeLeadStep();
                }
              }, 400);
            }
          );
          return;
        }

        if (attempt < 12) {
          window.setTimeout(function () {
            attachFormWatch(attempt + 1);
          }, 250);
        }
      }

      attachFormWatch();
    }

    function completeLeadStep() {
      if (leadCompleted || !pendingResultMeta) return;
      leadCompleted = true;
      persistResultsForRedirect();
      trackEvent('skin_quiz_lead_submit', {});
      showResult({ resultMeta: pendingResultMeta, clearStoredState: true });
    }

    function showResult(options) {
      options = options || {};

      var resultMeta = options.resultMeta || buildResultMeta();
      var result = {
        percent: resultMeta.percent,
        copy: resultMeta.copy
      };

      showScreen('result');
      updateProgress();

      if (resultCopy) resultCopy.textContent = result.copy;
      if (resultPercent) animateCounter(resultPercent, result.percent, 1400);

      trackEvent('skin_quiz_result', {
        percent: result.percent,
        raw_score: resultMeta.rawScore
      });

      if (options.clearStoredState !== false) {
        clearQuizResults();
      }
    }

    function renderQuestion(index) {
      var question = QUIZ_QUESTIONS[index];
      if (!question || !questionTitle || !optionsList) return;

      questionTitle.textContent = question.text;
      optionsList.innerHTML = '';

      question.options.forEach(function (option, optionIndex) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'skin-quiz__option';
        btn.textContent = option.label;
        btn.setAttribute('data-option-index', String(optionIndex));

        if (answers[question.id] === optionIndex) {
          btn.classList.add('is-selected');
        }

        btn.addEventListener('click', function () {
          answers[question.id] = optionIndex;
          trackEvent('skin_quiz_answer', {
            question_id: question.id,
            question_index: index + 1,
            answer: option.label,
            score: option.score
          });

          if (index < totalQuestions - 1) {
            currentQuestion = index + 1;
            renderQuestion(currentQuestion);
            updateProgress();
          } else {
            showScreen('lead');
            updateProgress();
            trackEvent('skin_quiz_questions_complete', { answers_count: totalQuestions });
          }
        });

        li.appendChild(btn);
        optionsList.appendChild(li);
      });

      if (backBtn) {
        backBtn.hidden = index === 0;
      }
    }

    if (startBtn) {
      startBtn.addEventListener('click', function () {
        answers = {};
        currentQuestion = 0;
        pendingResultMeta = null;
        leadCompleted = false;
        clearQuizResults();
        trackEvent('skin_quiz_start', {});
        showScreen('question');
        renderQuestion(0);
        updateProgress();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (currentStep !== 'question' || currentQuestion === 0) return;
        currentQuestion -= 1;
        renderQuestion(currentQuestion);
        updateProgress();
      });
    }

    if (retakeBtn) {
      retakeBtn.addEventListener('click', function () {
        answers = {};
        currentQuestion = 0;
        pendingResultMeta = null;
        leadCompleted = false;
        clearQuizResults();
        showScreen('intro');
        updateProgress();
        trackEvent('skin_quiz_retake', {});
      });
    }

    showScreen('intro');
    updateProgress();
  }

  function initAll() {
    document.querySelectorAll('[data-skin-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var quiz = event.target.querySelector('[data-skin-quiz]');
    if (quiz) initQuiz(quiz);
  });
})();
